import React, { Component } from "react";
import {
	Card,
	Divider,
	Icon,
	Table,
	Button,
	Popconfirm,
	message,
	Spin,
} from "antd";
import { decode } from "utf8";
import Modal from "./Modal";
import ModalEdit from "./ModalEdit";
import ModalDelete from "./ModalDelete";
import BillingDetails from "./Billingdetails";
import PaymentDetails from "./PaymentDetails";
import coloredRows from "./coloredRows.css";
import { connect } from "react-redux";

import {
	fetchUsers, // fetchCoupon
} from "appRedux/actions/Users";

function confirm(e) {}

function cancel(e) {}

function status(status) {
	if (status == 1) {
		return "Personal";
	} else if (status == 2) {
		return "Empresa";
	}
}
function statusUser(status) {
	if (status == 0) {
		return "Inactivo";
	} else if (status == 1) {
		return "Activo";
	}
}
class Simple extends Component {
	componentDidMount() {
		this.props.fetchUsers();
	}
	setRowClassName = (record) => {
		return record.user_status_description === "Activo"
			? "active_product"
			: "inactive_product";
	};

	render() {
		const columns = [
			{
				title: "Identificación",
				dataIndex: "identification",
				key: "identification",
				render: (text) => <span>{text}</span>,
			},
			{
				title: "Nombre",
				dataIndex: "name",
				key: "name",
				render: (text) => <span>{text}</span>,
			},
			{
				title: "Correo",
				dataIndex: "email",
				key: "email",
			},

			,
			{
				title: "Tipo de cuenta",
				dataIndex: "acccountType_description",
				key: "acccountType_description",
			},
			{
				title: "Estado",
				dataIndex: "user_status_description",
				key: "user_status_description",
			},

			{
				title: "Teléfono",
				dataIndex: "phone",
				key: "phone",
			},
			{
				key: "billdetails",
				render: (text, record) => (
					<span>
						<BillingDetails recording={record} />
					</span>
				),
			},
			,
			{
				key: "paymentdetails",
				render: (text, record) => (
					<span>
						<PaymentDetails recording={record} />
					</span>
				),
			},

			{
				title: "Acción",
				key: "action",

				render: (text, record) => (
					<span>
						<ModalEdit recording={record} />
						<ModalDelete recording={record} />
					</span>
				),
			},
		];

		const { users } = this.props;
		//console.log(users);
		let usersDecode = [];
		usersDecode = users.map((users) => {
			return {
				identification: users.identification,
				id: users.id,
				name: users.full_name,
				email: users.email,
				phone: users.phone,
				user_status: users.status,
				user_status_description: statusUser(users.status),
				acccountType_description: status(users.account_type),
				acccountType: users.account_type,
			};
		});

		if (usersDecode == 0) {
			return <Spin className="gx-loader-container" />;
		}

		return (
			<Card title="Usuarios">
				<Modal />
				<br />
				<Table
					className="gx-table-responsive"
					columns={columns}
					dataSource={usersDecode}
					rowClassName={this.setRowClassName}
				/>
			</Card>
		);
	}
}

function mapStateToProps({ users }) {
	return {
		users,
	};
}

export default connect(mapStateToProps, { fetchUsers })(Simple);



// WEBPACK FOOTER //
// ./src/routes/main/Admin/Table.js